<section class="aca-mig__card aca-mig__cardpad">
  <label class="aca-mig__field" style="max-width: 420px">
    <span class="aca-mig__label">{{ 'DMS.MIGRATION.MAP_PICK_JOB' | translate }}</span>
    <select class="aca-mig__select" [ngModel]="selectedId()" (ngModelChange)="pick($event)">
      <option *ngFor="let j of jobs()" [value]="j.id">{{ j.name }}</option>
    </select>
  </label>

  <div class="aca-mig__empty" *ngIf="!job">
    <mat-icon>alt_route</mat-icon>
    <div class="aca-mig__emptytitle">{{ 'DMS.MIGRATION.MAP_NO_JOB' | translate }}</div>
    <div>{{ 'DMS.MIGRATION.MAP_NO_JOB_DESC' | translate }}</div>
  </div>

  <ng-container *ngIf="job">
    <div class="aca-mig__tabs" style="margin-bottom: 12px">
      <button type="button" class="aca-mig__tab" *ngFor="let t of tables" [class.aca-mig__tab--on]="mapTable === t" (click)="mapTable = t">
        {{ 'DMS.MIGRATION.MAP_' + t.toUpperCase() | translate }}
      </button>
    </div>

    <div style="display: flex; gap: 10px; margin-bottom: 12px; flex-wrap: wrap">
      <input
        class="aca-mig__input"
        style="flex: 1; min-width: 160px"
        type="text"
        [(ngModel)]="newMapSource"
        [placeholder]="'DMS.MIGRATION.PH_MAP_SOURCE' | translate"
        [attr.aria-label]="'DMS.MIGRATION.PH_MAP_SOURCE' | translate"
      />
      <span style="align-self: center">→</span>
      <input
        class="aca-mig__input"
        style="flex: 1; min-width: 160px"
        type="text"
        [(ngModel)]="newMapTarget"
        [placeholder]="'DMS.MIGRATION.PH_MAP_TARGET' | translate"
        [attr.aria-label]="'DMS.MIGRATION.PH_MAP_TARGET' | translate"
      />
      <input
        class="aca-mig__input"
        style="flex: 1; min-width: 140px"
        type="text"
        [(ngModel)]="newMapDefault"
        [placeholder]="'DMS.MIGRATION.PH_MAP_DEFAULT' | translate"
        [attr.aria-label]="'DMS.MIGRATION.PH_MAP_DEFAULT' | translate"
      />
      <button type="button" class="aca-mig__btn" [disabled]="!newMapSource.trim()" (click)="addRow()">
        {{ 'DMS.MIGRATION.MAP_ADD' | translate }}
      </button>
    </div>

    <div class="aca-mig__empty" *ngIf="!job.mapping[mapTable].length" style="padding: 24px">
      <mat-icon>alt_route</mat-icon>
      <div>{{ 'DMS.MIGRATION.MAP_EMPTY' | translate }}</div>
    </div>

    <div class="aca-mig__tablewrap" *ngIf="job.mapping[mapTable].length">
      <table class="aca-mig__table">
        <thead>
          <tr>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_SOURCE_FIELD' | translate }}</th>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DEST_FIELD' | translate }}</th>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_ACTION' | translate }}</th>
            <th class="aca-mig__th">{{ 'DMS.MIGRATION.COL_DEFAULT' | translate }}</th>
            <th class="aca-mig__th" style="width: 40px"></th>
          </tr>
        </thead>
        <tbody>
          <tr class="aca-mig__row" *ngFor="let row of job.mapping[mapTable]; let i = index; trackBy: trackByRow">
            <td class="aca-mig__td aca-mig__mono">{{ row.source }}</td>
            <td class="aca-mig__td aca-mig__mono">{{ row.target || '—' }}</td>
            <td class="aca-mig__td">
              <select class="aca-mig__select" style="height: 28px" [(ngModel)]="row.action">
                <option value="map">{{ 'DMS.MIGRATION.MAP_MAP' | translate }}</option>
                <option value="ignore">{{ 'DMS.MIGRATION.MAP_IGNORE' | translate }}</option>
                <option value="default">{{ 'DMS.MIGRATION.MAP_DEFAULT' | translate }}</option>
                <option value="create">{{ 'DMS.MIGRATION.MAP_CREATE' | translate }}</option>
                <option value="review">{{ 'DMS.MIGRATION.MAP_REVIEW' | translate }}</option>
              </select>
            </td>
            <td class="aca-mig__td aca-mig__mono">{{ row.defaultValue || '—' }}</td>
            <td class="aca-mig__td">
              <button type="button" class="aca-mig__iconbtn" (click)="removeRow(i)"><mat-icon>close</mat-icon></button>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div style="margin-top: 14px">
      <button type="button" class="aca-mig__btn aca-mig__btn--primary" [disabled]="busy()" (click)="save()">
        {{ 'DMS.MIGRATION.SAVE' | translate }}
      </button>
    </div>
  </ng-container>
</section>
